import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const NAV_LINKS = [
  { label: 'Home', href: '#hero' },
  { label: 'About', href: '#features' },
  { label: 'Membership', href: '#membership' },
  { label: 'Academy', href: '#academy' },
  { label: 'Community', href: 'community-hub' },
  { label: 'Contact', href: '#hero' },
];

const SOCIAL = [
  { label: 'Instagram', icon: '📸' },
  { label: 'LinkedIn', icon: '💼' },
  { label: 'Twitter/X', icon: '🐦' },
  { label: 'Facebook', icon: '👥' },
];

const LandingFooter = () => {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);
  const navigate = useNavigate();

  const handleSubscribe = (e) => {
    e?.preventDefault();
    if (email) {
      setSubscribed(true);
      setEmail('');
    }
  };

  const scrollTo = (id) => {
    const el = document.querySelector(id);
    if (el) el?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleFooterLink = (href) => {
    if (!href?.startsWith('#')) {
      navigate('/' + href);
      return;
    }
    scrollTo(href);
  };

  return (
    <footer className="bg-[#0B1F3B] border-t border-[#D4A520]/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8 sm:py-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-10 sm:mb-12 text-center md:text-left">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center justify-center md:justify-start gap-3 mb-4">
              <div className="w-10 h-10 rounded-full overflow-hidden flex items-center justify-center">
                <img
                  src="/assets/images/Golden_coins_Win_Logo-1772863636273.png"
                  alt="WIN gold coin logo"
                  className="w-full h-full object-cover"
                />
              </div>
              <span className="text-[#D4A520] font-bold text-xl" style={{ fontFamily: 'Cormorant Garamond, serif' }}>WIN</span>
            </div>
            <p className="text-white/50 text-sm leading-relaxed mb-4">
              Women Investment Network — building wealth, community, and legacy together.
            </p>
            <div className="flex gap-3 justify-center md:justify-start">
              {SOCIAL?.map((s) => (
                <button
                  key={s?.label}
                  className="w-9 h-9 rounded-lg bg-white/5 hover:bg-[#D4A520]/20 flex items-center justify-center text-sm transition-all duration-200 hover:scale-110"
                  title={s?.label}
                >
                  {s?.icon}
                </button>
              ))}
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4 tracking-widest uppercase">Navigation</h4>
            <ul className="space-y-3">
              {NAV_LINKS?.map((link) => (
                <li key={link?.label}>
                  <button
                    onClick={() => handleFooterLink(link?.href)}
                    className="text-white/50 hover:text-[#D4A520] text-sm transition-colors duration-200"
                  >
                    {link?.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4 tracking-widest uppercase">Legal</h4>
            <ul className="space-y-3">
              {['Privacy Policy', 'Terms of Service', 'Cookie Policy', 'Disclaimer']?.map((item) => (
                <li key={item}>
                  <button className="text-white/50 hover:text-[#D4A520] text-sm transition-colors duration-200">{item}</button>
                </li>
              ))}
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4 tracking-widest uppercase">Stay Connected</h4>
            <p className="text-white/50 text-sm mb-4">Get investment insights and WIN updates delivered to your inbox.</p>
            {subscribed ? (
              <div className="bg-[#D4A520]/15 border border-[#D4A520]/30 rounded-xl p-3 text-[#D4A520] text-sm text-center">
                ✓ You're on the list!
              </div>
            ) : (
              <form onSubmit={handleSubscribe} className="flex flex-col gap-2">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e?.target?.value)}
                  placeholder="your@email.com"
                  className="w-full px-4 py-2.5 bg-white/5 border border-white/10 rounded-xl text-white placeholder-white/30 text-sm focus:outline-none focus:border-[#D4A520]/50 transition-colors"
                />
                <button
                  type="submit"
                  className="w-full py-2.5 bg-[#D4A520] text-[#0B1F3B] font-bold text-sm rounded-xl hover:bg-[#D4A520]/90 transition-all duration-200"
                >
                  Join Our List
                </button>
              </form>
            )}
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#D4A520]/15 pt-6 sm:pt-8 flex flex-col items-center gap-3 md:flex-row md:justify-between">
          <p className="text-white/30 text-xs text-center">© 2025 Women Investment Network. All rights reserved.</p>
          <p className="text-[#D4A520]/60 text-xs font-semibold tracking-widest uppercase">Invest In Each Other™</p>
          <p className="text-white/30 text-xs text-center">Not financial advice. Investment involves risk.</p>
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter;
